import React, {Component} from "react";
import "./Featured.css";

class Featured extends Component {
    render() {
        return (
            <div>
                <h2>#Featured</h2>
                <p></p>
                <div className="scroll-horizontal">
                    <div className="card-blog">
                        <div className="featured-box-one">
                        
                            {/* <img src="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/img/simple2_1.png"  alt="article0" /> */}

                            <a href="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/">
                                
                                <h5>Chris  Olah</h5>
                            </a>
        
                        </div> 
                        <h3>Neural Networks, Manifolds, and Topology</h3> 
                    </div>     
                    
                    <br />
                    <div className="card-blog">
                        <div className="featured-box-two">
                        
                            {/* <img src="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/img/simple2_1.png"  alt="article0" /> */}

                            <a href="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/">
                                
                                <h5>AlphaStar Team</h5>
                            </a>
        
                        </div> 
                        <h3>AlphaStar | DeepMind</h3> 
                    </div> 
                    <div className="card-blog">
                        <div className="featured-box-three">
                        
                            {/* <img src="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/img/simple2_1.png"  alt="article0" /> */}

                            <a href="https://medium.com/@durgaswaroop/a-practical-introduction-to-kafka-storage-internals-d5b544f6925f">
                                
                                <h5>Durga Swaroop Perla</h5>
                            </a>
        
                        </div> 
                        <h3>A Practical Introduction to Kafka Storage Internals</h3> 
                    </div> 


                    <div className="card-blog">
                        <div className="featured-box-four">
                        
                            {/* <img src="https://colah.github.io/posts/2014-03-NN-Manifolds-Topology/img/simple2_1.png"  alt="article0" /> */}

                            <a href="https://www.topcoder.com/community/competitive-programming/tutorials/dynamic-programming-from-novice-to-advanced/">
                                
                                <h5>Dumitru</h5>
                            </a>
        
                        </div> 
                        <h3>TopCoder DP Tutorial Blog</h3> 
                    </div> 
                </div>  
            </div>    
        );
    }
}

export default Featured;
